<div mat-dialog-title>
  <div class="dialog-header">
    <div class="title">Task Details</div>
    <div class="actions">
      <mat-icon svgIcon="close" class="action-icon" (click)="close()"></mat-icon>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="task-details-content">
    <div class="info">
      @if (task.status) {
        <div class="row"><div class="label">Status</div><div class="value"><div class="status" [ngClass]="task.status">{{ task.status }}</div></div></div>
      }
      <div class="row"><div class="label">Name</div><input class="input" [(ngModel)]="task.name" placeholder="Name"></div>
      <div class="row"><div class="label">Key</div><input class="input" [(ngModel)]="task.key"></div>
      <div class="row"><div class="label">Type</div><input class="input" [(ngModel)]="task.type"></div>
      @if (task.group) {
        <div class="row"><div class="label">Group</div><div class="value">{{ task.group }}</div></div>
      }
      @if (task.fileName) {
        <div class="row"><div class="label">File</div><div class="value">{{ task.fileName }}</div></div>
      }
      @if (task.timeStart) {
        <div class="row">
          <div class="label">Started</div>
          <div class="value" [title]="task.timeStart">{{ task.timeStart | date: 'medium' }}</div>
        </div>
      }
      @if (task.timeEnd) {
        <div class="row">
          <div class="label">Ended</div>
          <div class="value" [title]="task.timeEnd">{{ task.timeEnd | date: 'medium' }}</div>
        </div>
      }
      @if (task.timeStart && task.timeEnd && task.timeStart !== task.timeEnd) {
        <div class="row">
          <div class="label">Duration</div>
          <div class="value"><div class="time" [title]="task.timeStart + ' → ' + task.timeEnd">{{ task.timeStart | timeFormat: task.timeEnd }}</div></div>
        </div>
      }
    </div>
    @if (needs.length) {
      <div class="needs">
        <div class="label">Needs</div>
        <div class="tasks">
          @for (need of needs; track $index) {
            <div class="task">
              <div class="status" [ngClass]="need.status">{{ need.status || 'n/a' }}</div>
              <div class="name">{{ need.title }}</div>
            </div>
          }
        </div>
      </div>
    }
    <div class="body">
      <div class="label">Body (JSON)</div>
      <textarea class="body-input" [(ngModel)]="bodyText" spellcheck="false"></textarea>
    </div>
  </div>
</div>
<div mat-dialog-actions class="mat-dialog-actions dialog-actions">
  <div class="button secondary" (click)="close()">Cancel</div>
  <div class="button" (click)="save()">Save</div>
</div>
